import { Layout } from 'antd';
import React from 'react';
import MasterHeader from './master_header';

const { Header, Content, Sider } = Layout;
const MasterLayout = ({children}) => {
    return (
        <>
            <Layout>
                <Layout>
                    <Header style={{background : '#fff'}}>
                        <MasterHeader />
                    </Header>
                    <Content className='main-content'>
                        <div className='content'>
                            {children}
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    );
}

export default MasterLayout;